export default __webpack_public_path__ + "static/media/user-profile.411c2804.svg";